export const DESKTOPS = '@media (min-width: 1281px)'
export const LAPTOPS_DESKTOPS =
  '@media (min-width: 1025px) and (max-width: 1280px)'

export const TABLETS_HORIZONTAL = '@media (max-width: 1200px)'
export const TABLETS = '@media (max-width: 1024px)'
export const NOT_TABLETS = '@media (min-width: 1025px)'

export const TABLETS_IPADS_PORTRAIT =
  '@media (min-width: 768px) and (max-width: 1024px)'
export const TABLETS_IPADS_LANDSCAPE =
  '@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)'

export const PHONES = '@media (max-width: 767px)'
export const NOT_PHONES = '@media (min-width: 768px)'

export const LOW_RES_TABLETS_SMARTPHONES =
  '@media (min-width: 481px) and (max-width: 767px)'
export const SMARTPHONES = '@media (min-width: 320px) and (max-width: 480px)'
